class YTPrivacyNotice
{
    static manage()
    {
        const privacyNotices = document.querySelectorAll('.yt__privacy-notice');

        if (privacyNotices.length === 0) {
            return;
        }

        document.addEventListener('visitorConsentCollected', event => {
            const showNotices = !event.detail.marketingAllowed && !YTPrivacyNotice.checkYoutubeConsent();

            YTPrivacyNotice.togglePrivacyNotices(privacyNotices, showNotices);
        });

        const marketingAllowed = window.Shopify?.customerPrivacy?.marketingAllowed();
        const youtubeConsent = YTPrivacyNotice.checkYoutubeConsent();

        if (!marketingAllowed && !youtubeConsent) {
            privacyNotices.forEach(privacyNotice => {
                privacyNotice.parentElement.addEventListener('click', () => {
                    window.Shopify?.customerPrivacy?.setTrackingConsent({ metafields: [{ key: 'youtube', value: 'true' }] });
                    YTPrivacyNotice.togglePrivacyNotices(privacyNotices, false);
                });
            });

            return;
        }

        YTPrivacyNotice.togglePrivacyNotices(privacyNotices, false);
    }

    static togglePrivacyNotices(privacyNotices, show)
    {
        privacyNotices.forEach(privacyNotice => {
            privacyNotice.style.display = show ? 'block' : 'none';
        });
    }

    static checkYoutubeConsent()
    {
        return window.Shopify?.customerPrivacy?.getTrackingConsentMetafield('youtube') === 'true';
    }
}

YTPrivacyNotice.manage();
